import React from 'react';
import './PrivacyPolicyModal.css';

const PrivacyPolicyModal = ({ onAccept, canClose = false, onClose = null }) => {
  return (
    <div className="privacy-modal-overlay">
      <div className="privacy-modal">
        <div className="privacy-modal-header">
          <h2>Privacy Policy</h2>
          {canClose && onClose && (
            <button className="close-button" onClick={onClose}>×</button>
          )}
        </div>

        <div className="privacy-modal-content">
          <p className="privacy-intro">
            <strong>Effective Date:</strong> December 2, 2025
          </p>

          <p className="privacy-intro">
            Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal and financial information when you use our personal finance application.
          </p>

          <h3>1. Information We Collect</h3>
          <p>We collect the following types of information:</p>
          <ul>
            <li><strong>Account Information:</strong> When you sign up using Google OAuth, we collect your name, email address, and profile picture from your Google account.</li>
            <li><strong>Financial Data:</strong> Through Stripe Financial Connections, we access your bank account information, transaction history, and account balances to provide our services.</li>
            <li><strong>Transaction Data:</strong> We store and process your transaction information including amounts, dates, categories, and descriptions.</li>
            <li><strong>Usage Data:</strong> We may collect information about how you use the application, including features accessed and preferences set.</li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and improve our personal finance management services</li>
            <li>Sync and categorize your financial transactions</li>
            <li>Create budgets and spending insights</li>
            <li>Send you important updates about your account</li>
            <li>Ensure the security and integrity of our services</li>
          </ul>

          <h3>3. Data Sharing and Third Parties</h3>
          <p>We work with the following third-party services:</p>
          <ul>
            <li><strong>Google OAuth:</strong> For secure authentication</li>
            <li><strong>Stripe Financial Connections:</strong> For secure bank account connectivity and transaction syncing</li>
          </ul>
          <p>We do not sell your personal or financial information to third parties. We only share data with these service providers as necessary to operate our application.</p>

          <h3>4. Data Security</h3>
          <p>We implement industry-standard security measures to protect your data:</p>
          <ul>
            <li>All data is transmitted using secure HTTPS connections</li>
            <li>Financial data is accessed through Stripe's secure Financial Connections API</li>
            <li>We use secure session management and authentication</li>
            <li>Your data is stored in a secure database with access controls</li>
          </ul>

          <h3>5. Your Rights</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and associated data</li>
            <li>Disconnect your bank accounts at any time</li>
            <li>Export your transaction data</li>
          </ul>

          <h3>6. Data Retention</h3>
          <p>We retain your data for as long as your account is active. If you delete your account, we will remove your personal and financial data from our systems, subject to any legal retention requirements.</p>

          <h3>7. Children's Privacy</h3>
          <p>Our service is not intended for users under the age of 18. We do not knowingly collect information from children.</p>

          <h3>8. Changes to This Policy</h3>
          <p>We may update this Privacy Policy from time to time. We will notify you of any significant changes by email or through a prominent notice in the application.</p>

          <h3>9. Contact Us</h3>
          <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us.</p>
        </div>

        <div className="privacy-modal-footer">
          {!canClose ? (
            <>
              <p className="acceptance-notice">
                By clicking "Accept", you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and sharing of your information as described above.
              </p>
              <button className="button button-primary" onClick={onAccept}>
                Accept Privacy Policy
              </button>
            </>
          ) : (
            <button className="button button-secondary" onClick={onClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
